import React from 'react';
import styled from 'styled-components';
import { Button } from '@cuemath/comps';
import { SelectInput } from 'modules/form/index';
import { Grid, Input } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import { store } from 'redux-rest-reducer';
import { generate30minSlots, addTime, getEndOfWeek } from 'utils';
import COLOR from 'constants/colors';

const slotOptionsBeginHours = 2;

const Label = styled.label`
  font-weight: 600;
`;

const StarIcon = styled.span`
  color: ${COLOR.RED};
`;

const InputField = styled(Input)`
  width: 100%;
  cursor: ${props => (props.disabled ? 'not-allowed' : '')};
`;

const ButtonWrapper = styled.div`
  margin-top: 17px;
`;

export default function StudentFilter({
  studentId,
  getTeacherMappingForm,
  formValues,
  setFormValues,
}) {
  const { students, teacherMappingParams } = useSelector(store => {
    return {
      students: store.students,
      teacherMappingParams: store.teacherMapping,
    };
  });
  const { data: studentDetails } = store.get(students, studentId);
  const { data: teacherMappingOptions } = store.get(
    teacherMappingParams,
    'teacher_mapping_param_options',
  );

  const handleDropDownChange = (option, action) => {
    setFormValues(action.name, option);
  };
  const { name, grade, exams, country, board, languages, native } = studentDetails || {};
  const {
    name: formName,
    grade: formGrade,
    exams: formExams,
    country: formCountry,
    board: formBoard,
    languages: formLanguages,
    native: formNative,
    slot: formSlot,
  } = formValues || {};
  const {
    boards: boardsOptions,
    exams: examsOptions,
    native: nativeOptions,
    languages: languagesOptions,
  } = teacherMappingOptions || {};

  const slotOptions = generate30minSlots(
    addTime(new Date(), 0, slotOptionsBeginHours),
    getEndOfWeek(),
  );

  return (
    <Grid columns={5}>
      <Grid.Row>
        <Grid.Column key="student_name">
          <Label>Student Name</Label>
          <InputField
            name="name"
            placeholder="Name"
            value={formName || name}
            disabled={true}
          />
        </Grid.Column>
        <Grid.Column key="student_grade">
          <Label>Student Grade</Label>
          <InputField
            name="grade"
            placeholder="Grade"
            value={formGrade || grade}
            disabled={true}
          />
        </Grid.Column>
        <Grid.Column key="student_country">
          <Label>Student Country</Label>
          <InputField
            name="country"
            placeholder="Country"
            value={formCountry || country}
            disabled={true}
          />
        </Grid.Column>
        <Grid.Column key="student_board">
          <Label>Student Curriculum/Board</Label>
          <SelectInput
            name="board"
            width="100%"
            defaultValue={board}
            onChange={handleDropDownChange}
            getOptionLabel={option => option.name}
            getOptionValue={option => option.code}
            value={formBoard}
            options={boardsOptions}
            isClearable={true}
          />
        </Grid.Column>
        <Grid.Column key="student_language">
          <Label>Language</Label>
          <SelectInput
            name="languages"
            width="100%"
            defaultValue={languages}
            onChange={handleDropDownChange}
            getOptionLabel={option => option.name}
            getOptionValue={option => option.code}
            value={formLanguages}
            options={languagesOptions}
            isMulti={true}
          />
        </Grid.Column>
        <Grid.Column key="exams">
          <Label>Specialization in exam</Label>
          <SelectInput
            width="100%"
            defaultValue={exams}
            name="exams"
            onChange={handleDropDownChange}
            getOptionLabel={option => option.name}
            getOptionValue={option => option.code}
            value={formExams}
            options={examsOptions}
            isMulti={true}
          />
        </Grid.Column>
        <Grid.Column key="native">
          <Label>Native</Label>
          <SelectInput
            width="100%"
            defaultValue={native}
            name="native"
            onChange={handleDropDownChange}
            getOptionLabel={option => option.name}
            getOptionValue={option => option.code}
            value={formNative}
            isClearable={true}
            options={nativeOptions}
          />
        </Grid.Column>
        <Grid.Column key="slot">
          <Label>Slot</Label>
          <SelectInput
            width="100%"
            name="slot"
            onChange={handleDropDownChange}
            getOptionLabel={option => option.name}
            getOptionValue={option => option.code}
            value={formSlot}
            isClearable={true}
            options={slotOptions}
          />
        </Grid.Column>
        <Grid.Column key="button" width={2}>
          <ButtonWrapper>
            <Button label="Apply" disabled={!studentId} onClick={getTeacherMappingForm} />
          </ButtonWrapper>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}
